function getBrandSnippetPrompt(entity, category) {
    return `
            You are a LLM describing a brand ${entity} for category ${category} to a user. Give me a 8-10 word phrase that you would use. Respond with only a JSON structure as following:
            {
            "data": ["phrase"]
            }
            Do not include any explanatory text before or after the JSON.
            `;
}

function getBrandThemePrompt(entity, category) {
    return `
      Define the ${entity} brand for category ${category} using exactly 4 keywords. Respond with only a JSON object containing an array of 4 strings, following this precise structure:
      {
      "data": ["keyword1", "keyword2", "keyword3", "keyword4"]
      }
      Do not include any explanatory text before or after the JSON.
      `;
}

function getBrandDescriptionPrompt(entity, category) {
    return `Provide a 50-word description for ${entity} in ${category} category. Respond only with the description, without any introductory phrases or qualifiers`
}

function getCategoryPrompt(brand) {
    return `For the brand or product name '${brand}', list the **top 5 brand product categories** describing its market segment, primary use, or type. **Rules:** - Use only broad functional or market classifications. - Exclude model names, series names, version numbers, and product lines. - Categories must be widely recognized without brand knowledge. - Focus on role, form factor, target market, or core features. **Output (strict):** {\"categories\": [\"Category1\", \"Category2\", \"Category3\", \"Category4\", \"Category5\"]} No explanations or extra text.`;
}

function getCategoryTypePrompt(brand, category) {
    return `Suggest the **top 5 most relevant category types** for the brand or product '${brand}' in the category '${category}'. 

- Use specific domain types when applicable (e.g., 'universities', 'schools', 'hospitals', 'airlines', 'agencies').  
- If appropriate, include broader types like 'companies', 'brands', or 'products' (e.g., Samsung in mobiles → 'companies').  
- Do not provide explanations or text outside the required JSON.  

**Output strictly in JSON format:**  
{"categoryTypes": ["Type1", "Type2", "Type3", "Type4", "Type5"]}`;
}

export {
    getBrandDescriptionPrompt, getBrandSnippetPrompt,
    getBrandThemePrompt, getCategoryPrompt, getCategoryTypePrompt
};

